export default __webpack_public_path__ + "static/media/download.1a740729.svg";